module.exports = __webpack_public_path__ + "7a2621c34a54dc2e61c89eda511927f1.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/500_r_50.mp3
// module id = 430
// module chunks = 0